import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { LoginPage } from "./LoginPage";
import { AdminWorkspace } from "./AdminWorkspace";
import { EventsPage } from "./EventsPage";
import { AnnouncementsPanel } from "./AnnouncementsPanel";
import { SettingsPage } from "./SettingsPage";
import { VisitorEventRequestsPage } from "./VisitorEventRequestsPage";
import { CorrectionReportsPage } from "./CorrectionReportsPage";

function RequireAuth({ children }: { children: ReactNode }) {
  const loc = useLocation();
  const [state, setState] = useState<"loading" | "in" | "out">("loading");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const me = await fetch("/api/auth/me", { credentials: "include" });
        const j = (await me.json()) as { ok?: boolean };
        if (!alive) return;
        setState(j.ok ? "in" : "out");
      } catch {
        if (!alive) return;
        setState("out");
      }
    })();
    return () => {
      alive = false;
    };
  }, [loc.pathname]);

  if (state === "loading") return <div className="admin-shell">読み込み中…</div>;
  if (state === "out") return <Navigate to="/admin/login" replace state={{ from: loc.pathname }} />;
  return <>{children}</>;
}

export function AdminApp() {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="menu" element={<Navigate to="/admin/events/all" replace />} />
      <Route path="pending" element={<Navigate to="/admin/events/all" replace />} />
      <Route path="archive" element={<Navigate to="/admin/events/archive" replace />} />

      <Route
        element={
          <RequireAuth>
            <AdminWorkspace />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="events/all" replace />} />
        <Route path="announcements" element={<AnnouncementsPanel />} />
        <Route path="fan-notifications" element={<Navigate to="/admin/announcements" replace />} />
        <Route path="visitor-requests" element={<VisitorEventRequestsPage />} />
        <Route path="correction-reports" element={<CorrectionReportsPage />} />
        <Route path="ingest-logs" element={<Navigate to="/admin/events/karin" replace />} />
        <Route path="events/:mode" element={<EventsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="reserve-check" element={<Navigate to="/admin/events/all" replace />} />
        <Route path="*" element={<Navigate to="/admin/events/all" replace />} />
      </Route>

      <Route path="*" element={<Navigate to="/admin/events/all" replace />} />
    </Routes>
  );
}
